import React from 'react';
import { motion } from 'framer-motion';
import { BsPlusLg } from 'react-icons/bs';

interface PostOpportunityButtonProps {
    onClick: () => void;
}

const PostOpportunityButton: React.FC<PostOpportunityButtonProps> = ({ onClick }) => {
    return (
        <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onClick}
            className="fixed bottom-8 right-8 z-50 flex items-center gap-3 px-6 py-4 bg-gradient-to-r from-premium-gold-dark via-premium-gold to-premium-gold-light text-premium-wood-dark font-serif font-bold text-lg rounded-full shadow-[0_0_30px_rgba(212,175,55,0.4)] hover:shadow-[0_0_40px_rgba(212,175,55,0.6)] transition-shadow border border-white/20"
        >
            <BsPlusLg className="w-5 h-5" />
            Post Opportunity
        </motion.button>
    );
};

export default PostOpportunityButton;
